/* eslint-disable */
// @ts-ignore
import axios, { AxiosRequestConfig } from 'axios';
import { InteractionRequiredAuthError, IPublicClientApplication } from '@azure/msal-browser';
import { msalInstance } from '../main';
import { API_URL, MSAL_SCOPES } from '../config';

const axiosInstance = axios.create({
   baseURL: API_URL,
   // baseURL: 'https://localhost:3005',
});

export function getAccessToken(
  instance: IPublicClientApplication,
  scopes: string[] = MSAL_SCOPES,
): Promise<string | undefined> {
  const accounts = instance.getAllAccounts();
  return instance
    .acquireTokenSilent({
      scopes,
      account: accounts[0],
    })
    .catch((error) => {
      if (error instanceof InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        return instance.acquireTokenRedirect({ scopes });
      }
      throw error;
    })
    .then((tokenResponse) => tokenResponse?.accessToken);
}

axiosInstance.interceptors.request.use(
  // @ts-expect-error
  async (config: AxiosRequestConfig) => {
    const customScopes = config.customScopes;
    const tokenResponse = customScopes
      ? await getAccessToken(msalInstance, customScopes)
      : await getAccessToken(msalInstance);

    // @ts-expect-error axios bug workaround, ref: https://github.com/axios/axios/issues/5034
    config.headers.Authorization = `Bearer ${tokenResponse}`;
    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
